export let SALES_ANALYTICS_WIDGETS;
(function (SALES_ANALYTICS_WIDGETS) {
  SALES_ANALYTICS_WIDGETS["WATERFALL"] = "WATERFALL";
  SALES_ANALYTICS_WIDGETS["CHANGE_HISTORY_DEAL_LIST"] = "CHANGE_HISTORY_DEAL_LIST";
  SALES_ANALYTICS_WIDGETS["DEAL_PUSH_ANALYSIS"] = "DEAL_PUSH_ANALYSIS";
  SALES_ANALYTICS_WIDGETS["PIPELINE_SNAPSHOTS"] = "PIPELINE_SNAPSHOTS";
  SALES_ANALYTICS_WIDGETS["SALES_QUOTA"] = "SALES_QUOTA";
  SALES_ANALYTICS_WIDGETS["COMPLETED_ACTIVITIES"] = "COMPLETED_ACTIVITIES";
})(SALES_ANALYTICS_WIDGETS || (SALES_ANALYTICS_WIDGETS = {}));